/**
 * @name APP cmmApp
 * @autor camila.montenegro@u-planner.com
 * @description Tabla para Campus
 * # name controller --> tableCtrl
 */

	export default class tableCtrl {


	constructor($rootScope, $scope, $http , $filter, tablesServices,$stateParams, ngNotify,SERVICE_URL_CONSTANT,$window,permissions,permissionList, uFunctions, $timeout){
       /*  permissionList["filtertableedit"]=true;
        permissions.setPermissions(); */
		function ucfirst(st){
			return st.substring(0, 1).toUpperCase() + st.substring(1).toLowerCase();
		}
		$scope.type=$stateParams['type'];
		$scope.title=ucfirst($scope.type);
		var vm=this;
		vm.$translate = $filter('translate')
		vm.$timeout = $timeout
		vm.url=""
		vm.disableCSV=false
		var nci=[
			{ 
				name: 'Nombre',
				field: 'des_nombre_'+$scope.type,
			},
			{
				name: 'Código',
				field: 'id_publica_'+$scope.type,
			},   
			{
				name: 'id_Integración',
				field: 'cod_integracion_'+$scope.type,
			}
		]       
        if (permissions.hasPermission("filtertableedit")){
			var switchs=[{
				name: 'Sincronizable',
                field:$scope.type+'_sincronizable',
				width: '10%',
                enableFiltering: false,
				 cellTemplate:'<div class="ui-grid-cell-contents">'+
							 '<span>'+
							 '<label class="md-switch">'+
							 '<input type="checkbox" aria-label="Sincronizable" ng-model="grid.appScope.model[row.entity.cod_integracion_'+$scope.type+'].sincronizable"'+
							 ' ng-click="grid.appScope.modelSave[((row.entity.cod_alt)?row.entity.cod_alt:row.entity.cod_integracion_'+$scope.type+')].sincronizable=grid.appScope.model[row.entity.cod_integracion_'+$scope.type+'].sincronizable"><i class="green"></i></label></span>'+
                             '</div>',
			},
			{
				name: 'Estado',
                field:$scope.type+'_activa',
				width: '7%',
                enableFiltering: false,
				 cellTemplate:'<div class="ui-grid-cell-contents">'+
							 '<span><label class="md-switch">'+
							 '<input type="checkbox" aria-label="Sincronizable" ng-model="grid.appScope.model[row.entity.cod_integracion_'+$scope.type+'].activa"'+
							 ' ng-click="grid.appScope.modelSave[((row.entity.cod_alt)?row.entity.cod_alt:row.entity.cod_integracion_'+$scope.type+')].activa=grid.appScope.model[row.entity.cod_integracion_'+$scope.type+'].activa"><i class="green"></i></label></span>'+
                             '</div>',
			}]
		}else{
            var switchs=[{
				name: 'Sincronizable',
                field:$scope.type+'_sincronizable',
				width: '10%',
                enableFiltering: true
			},
			{
				name: 'Estado',
                field:$scope.type+'_activa',
				width: '7%',
                enableFiltering: true
			}];
        }
		
		
		
		var exp={data:[],headers:[],headerspdf:[]};
		switch($scope.type){
			case 'campus':
				var cols=nci.concat(switchs);
				tablesServices.services.getCampus({newPage:1, pageSize:10}).$promise
					.then(function(data){
						$scope.tabla.data = data.data;
                        $scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
				break;
			case 'jornada':
				var cols=nci.concat(switchs);
				tablesServices.services.getJornada({newPage:1, pageSize:10}).$promise
					.then(function(data){
						$scope.tabla.data = data.data;
                        $scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
                    
				break;
			case 'actividad':
				var cols=nci.concat(switchs);
				tablesServices.services.getActivity({newPage:1, pageSize:10}).$promise
					.then(function(data){
						$scope.tabla.data = data.data;
                        $scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
				break;
			case 'institucion':
				$scope.title='Institución';
				var cols=nci.concat(switchs);
				tablesServices.services.getInstitution({newPage:1, pageSize:10}).$promise
					.then(function(data){
						$scope.tabla.data = data.data;
                        if ($scope.tabla.data==undefined){console.log('raro');}
                        else{console.log($scope.tabla.data);}
                        $scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
				break;
			case 'unidad_academica':
				$scope.title="Departamento";
				var ua=[
					   { 
							name: 'Unidad Académica',
							field: 'des_nombre_unidad_academica',
						},
						{
							name: 'Código',
							field: 'id_publica_unidad_academica',
						},   
						{
							name: 'Id Integración',
							field: 'cod_integracion_unidad_academica',
						}];
				var cols=ua.concat(switchs);
				tablesServices.services.getUnidadAcademica({newPage:1, pageSize:10}).$promise
					.then(function(data){
						$scope.tabla.data = data.data;
                        $scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});

				break;
			case "tipo_uso":
				$scope.title="Tipo de Uso";
				var tp=[
				   { 
						name: 'Nombre',
						field: 'des_nombre_tipo_uso',
					},
					{
						name: 'Tipo uso Detalle',
						field: 'des_nombre_tipo_uso_detalle',
					},   
					{
						name: 'ID Integración Tipo uso Detalle',
						field: 'cod_integracion_tipo_uso'}
					];
				var cols=tp.concat(switchs);
					tablesServices.services.getTipoUso({newPage:1, pageSize:10}).$promise
					.then(function(data){
                        $scope.tabla.totalItems = data.size;
						$scope.tabla.data = data.data;
						$scope.booleanizar();
					});

					break;
			case "carrera":
				var cols=nci.concat(switchs);
					tablesServices.services.getCarrera({newPage:1, pageSize:10}).$promise
					.then(function(data){
						$scope.tabla.data = data.data;
                        $scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});

					break;
			case "ccepr":
				$scope.title="Campus Recursos";
				var ccepr=[
						{
							name: 'Campus',
							field: 'des_nombre_campus',
						},   
						{
							name: 'Edificio',
							field: 'des_nombre_edificio',
						},
						{
							name: 'Piso',
							field: 'des_nombre_piso',
						},
						 {
							name: 'Recurso',
							field: 'des_nombre_recurso',
						},
						{
							name: 'Capacidad',
							field: 'nm_capacity',
						},
						 {
							name: 'Código',
							field: 'id_publica_recurso',
						},
						{
							name: 'ID Integración',
							field: 'cod_integracion_ccepr',
						}];
				var cols=ccepr.concat(switchs);
					tablesServices.services.getRecurso({newPage:1, pageSize:10}).$promise
					.then(function(data){
						$scope.tabla.data = data.data;
                        $scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});

					break;
			case "cceprt":
				$scope.title="Recurso Tipo de Uso";
				var cceprt=[
						{
							name: 'Campus',
							field: 'des_nombre_campus',
						},   
						{
							name: 'Edificio',
							field: 'des_nombre_edificio',
						},
						{
							name: 'Piso',
							field: 'des_nombre_piso',
						},
						 {
							name: 'Recurso',
							field: 'des_nombre_recurso',
						},
						{
							name: 'Tipo de Uso',
							field: 'des_nombre_tipo_uso',
						}];
				var cols=cceprt.concat(switchs);
					tablesServices.services.getRecursoTipoUso({newPage:1, pageSize:10}).$promise
					.then(function(data){
						$scope.tabla.data = data.data;
                        $scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});

					break;
			case 'docente':
				var cols=nci.concat(switchs);
                tablesServices.services.getDocente({newPage:1, pageSize:10}).$promise
                .then(function(data){
                    $scope.tabla.data = data.data;
                    $scope.tabla.totalItems = data.size;
                    $scope.booleanizar();
                });
				

				break;
			case 'periodo':
				var cols=nci.concat(switchs);
				cols.unshift({name:'Tipo de periodo',field:'tipo_periodo'})
				$scope.myModel={selectedCampus:0};
				$scope.filterBlock=true;
				tablesServices.catalogues.getCatalogueCampus().$promise
					.then(function(data){
						$scope.cataloguesCampus = data;
						
						$scope.myModel.selectedCampus=''+$scope.cataloguesCampus.data[0].id_Sede;
						vm.filter();
					});

				break;
			case 'pm':
				$scope.title='Materias por Plan';
				var pm=[
					   { 
							name: 'Carrera',
							field: 'des_nombre_carrera',
						},
						{
							name: 'Plan',
							field: 'des_nombre_plan',
						},   
						{
							name: 'Nivel',
							field: 'nro_nivel',
                            // width: '10%',
						},   
						{
							name: 'Nombre Asignatura',
							field: 'nombre_asignatura',
						}];
				var cols=pm.concat(switchs);
				$scope.myModel={selectedCarrera:0, filter:'0'};
				$scope.filterBlockC=true;

				
				break;
			case 'ad':
                $scope.title='Docente Materia Actividad';
                    var ad=[{ 
                            name: 'Asignatura',
                            field: 'des_asignatura',
                        },
                        {
                            name: 'Actividad',
                            field: 'des_actividad',
                        },   
                        {
                            name: 'Docente',
                            field: 'des_nombre_apellido',
                        }];
				var cols=ad.concat(switchs);
				$scope.myModel={selectedApellido:0, filter:'0'};
				$scope.filterBlockD=true;
				
				break;
			case 'nota':
                $scope.title='Nota Clase';
				var cols=[
					   { 
							name: 'Nota Clase',
							field: 'des_nota_clase',
						},
						{
							name: 'Código',
							field: 'id_nota_clase',
						},   
						{
							name: 'Id Integración',
							field: 'cod_integracion_nota',
                        }]
                 if (permissions.hasPermission("filtertableedit")){
                     cols.push(
                        {
                            name: 'Estado',
                            field:$scope.type+'_activa',
                            width: '7%',
                             cellTemplate:'<div class="ui-grid-cell-contents">'+
                                         '<span><label class="md-switch">'+
                                         '<input type="checkbox" aria-label="Sincronizable" ng-model="grid.appScope.model[row.entity.cod_integracion_nota].activa"'+
                                         ' ng-click="grid.appScope.modelSave[row.entity.cod_integracion_nota].activa=grid.appScope.model[row.entity.cod_integracion_nota].activa"><i class="green"></i></label></span>'+
                                         '</div>',
                          });
                 }else{
                     cols.push(
                        {
                            name: 'Estado',
                            field:$scope.type+'_activa',
                            width: '7%'
                          });}
				$scope.filterBlockN=true;
                
				tablesServices.catalogues.getCatalogueCampus().$promise
					.then(function(data){
                        $scope.list=data.data;console.log(data.data);
                        tablesServices.services.getNotaClase({newPage:1, pageSize:10,id:data.data[0].id_Sede}).$promise
                        .then(function(data){
                           
                            $scope.tabla.data = data.data;
                            $scope.tabla.totalItems = data.size;
                            $scope.myModel={selectedCampus:0};
                            $scope.booleanizar();
                        });
					});
                    

				break;
				/*Modificar columna en tabla planes campus*/
			case 'cpjc':
				$scope.title='Planes en Campus';
				var cpjc=[
					  { 
						name: 'Campus',
						field: 'des_nombre_campus',
					  },
					  {
						name: 'Periodo',
						field: 'des_nombre_periodo',
					  },   
					  {
						name: 'Jornada',
						field: 'des_nombre_jornada',
					  },
					  {
						name: 'Carrera',
						field: 'des_nombre_carrera',
					  },
					  {
						name: 'Plan',
						field: 'des_nombre_plan',
					  }];
				var cols=cpjc.concat(switchs);
				$scope.myModel={selectedCampus:0};
				$scope.filterBlock=true;
				tablesServices.catalogues.getCatalogueCampus().$promise
					.then(function(data){
						$scope.cataloguesCampus = data;
						
						$scope.myModel.selectedCampus=$scope.cataloguesCampus.data[0].id_Sede;
						vm.filter();
					});

				break;
			case 'dm':
				$scope.title='Módulos por Jornada';
				var dm=[
					   { 
							name: 'Nombre',
							field: 'des_nombre_dia',
						},
						{
							name: 'Código',
							field: 'des_nombre_modulo',
						},
						{
							name:'Jornada',
							field:'des_jornada',
						}];
				var cols=dm.concat(switchs);
				$scope.myModel={selectedCampus:0};
				$scope.filterBlockCJ=true;

				function getCampus() {
					tablesServices.catalogues.getCatalogueCampus().$promise
					.then(function(data){
						$scope.cataloguesCampus = data;
						
						$scope.myModel.selectedCampus=$scope.cataloguesCampus.data[0].id_Sede;

						vm.getJornada($scope.myModel.selectedCampus);
						
					});
				}

				vm.getJornada = function (id_campus) {
					tablesServices.services.getJornadaSimple({ campus: id_campus }).$promise
							.then(function(data){
								$scope.cataloguesJornadas = data.data;
								if ($scope.cataloguesJornadas.length >0){
									$scope.myModel.selectedJornada=''+$scope.cataloguesJornadas[0].id_jornada;
									vm.filterCJ();
								}
							});
				}

				getCampus();

				break;
			case 'plan':
				$scope.title='Plan de Estudio';
				var cp=[{ 
						name: 'Carrera',
						field: 'des_nombre_carrera',
						width: '30%',
					},
					{
						name: 'Plan',
						field: 'des_nombre_plan',
						width: '30%',
					},   
					{
						name: 'Modalidad',
						field: 'modalidad',
						width: '15%',
					}, 
					{
						name: 'Código',
						field: 'id_publica_plan',
						width: '10%'
					}];
				var cols=cp.concat(switchs);
					tablesServices.services.getTable({newPage:1, pageSize:10}).$promise
					.then(function(data){
						$scope.tabla.data = data.data;
                        $scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});

					break;
			case 'aa':
				$scope.title='Materia Actividad';
				var aa=[{ 
						name: 'Asignatura',
						field: 'des_nombre_asignatura',
					},
					{
						name: 'Actividad',
						field: 'des_nombre_actividad',
					},   
					{
						name: 'Módulos por semana',
						field: 'nro_modulos_por_semana',
					},   
					{
						name: 'Módulos consecutivos',
						field: 'nro_cant_modulos_consecutivos',
					}, 
					{
						name: 'Cupo Académico',
						field: 'cupo',
					}];
                if (permissions.hasPermission("filtertableedit")){
                    aa[2].cellTemplate='<div class="ui-grid-cell-contents">'+
                                         '<input type="number" aria-label="Sincronizable" ng-model="grid.appScope.modelSave[row.entity.cod_integracion_'+$scope.type+'].nro_modulos_por_semana"'+
                                         'ng-value="row.entity.nro_modulos_por_semana">'+
                                         '</div>';
                    aa[3].cellTemplate='<div class="ui-grid-cell-contents">'+
                                         '<input type="number" aria-label="Sincronizable" ng-model="grid.appScope.modelSave[row.entity.cod_integracion_'+$scope.type+'].nro_Cant_Modulos_Consecutivos"'+
                                         'ng-value="row.entity.nro_Cant_Modulos_Consecutivos">'+
                                         '</div>'; 
                    
                }
				var cols=aa.concat(switchs);
					$scope.myModel={selectedUnidad:0};
					$scope.filterBlockUnit=true;
					tablesServices.catalogues.getCatalogueUnidadAcademica().$promise
						.then(function(data){
							$scope.cataloguesUnidad = data;
							
							$scope.myModel.selectedUnidad=$scope.cataloguesUnidad.data[0].id_unidad_academica;
							vm.filterUnit();
						});

					break;
			case 'uam':
				$scope.title='Materias por Departamento';
				var uam=[
					   { 
							name: 'Unidad Académica',
							field: 'des_nombre_unidad_academica',
						},
						{
							name: 'Asignatura',
							field: 'des_nombre_asignatura',
							width: '35%',
						},   
						{
							name: 'Código',
							field: 'cod_integracion_uam',
						}];
				var cols=uam.concat(switchs);
					$scope.myModel={selectedUnidad:0};
					$scope.filterBlockUnit=true;
					tablesServices.catalogues.getCatalogueUnidadAcademica().$promise
						.then(function(data){
							$scope.cataloguesUnidad = data;
							
							$scope.myModel.selectedUnidad=$scope.cataloguesUnidad.data[0].id_unidad_academica;
							vm.filterUnit();
						});

					break;
			case 'aau':
				$scope.title='Materia Actividad Tipo Uso';
				var aau=[{
						name: 'Unidad Academica',
						field: 'des_nombre_unidad_academica',
					},
				   { 
						name: 'Asignatura',
						field: 'des_nombre_asignatura',
						width: '35%',
					},
					{
						name: 'Actividad',
						field: 'des_nombre_actividad',
					},   
					{
						name: 'Tipo de Uso',
						field: 'des_nombre_tipo_uso',
					}];
				var cols=aau.concat(switchs);
					$scope.myModel={selectedUnidad:0};
					$scope.filterBlockUnit=true;
					tablesServices.catalogues.getCatalogueUnidadAcademica().$promise
						.then(function(data){
							$scope.cataloguesUnidad = data;
							
							$scope.myModel.selectedUnidad=$scope.cataloguesUnidad.data[0].id_unidad_academica;
							vm.filterUnit();
						});
					break;
			
		}
		$scope.model={};
		//// Table
        // for (var i in cols){
        //    if (cols[i]==undefined){delete(cols[i]);}
        //    else{
        //    if (!cols[i].cellTemplate){cols[i].cellTemplate='<div class="ui-grid-cell-contents" ng-binding ng-scope">{{COL_FIELD}}<md-tooltip md-direction="right" style="background-color:#000000;">{{COL_FIELD}}</md-tooltip></div>';}}
        // }
		$scope.tabla ={ 
			enableFiltering: true,
            enableGridMenu: true,
            paginationPageSizes: [10,25, 50, 75],
    		paginationPageSize: 10,
            useExternalPagination: true,
            onRegisterApi :function( gridApi ) {
                  gridApi.core.on.filterChanged( $scope, function() {
                      var grid = this.grid;
                      $scope.tabla.paginationNumber=1;
                      selectService(1,$scope.tabla.paginationPageSize,grid)
                    });
                  gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                      var grid = this.grid;
                      selectService(newPage, pageSize,grid);
                  });
                  gridApi = gridApi;
				  $rootScope.$watch("sidenavState", () => {
                    	$timeout(() => {
                            gridApi.grid.handleWindowResize();
                    	}, 50);
            	  });
              },
            
			columnDefs : cols
		};
		$scope.booleanizar=function(){
			$scope.modelSave={};
            if (permissions.hasPermission("filtertableedit")){
                for (var i in $scope.tabla.data){
                    //console.log($scope.tabla.data[i]);
                    var key=$scope.tabla.data[i]['cod_integracion_'+$scope.type];
                    if ($scope.tabla.data[i][$scope.type+'_sincronizable']==1){$scope.tabla.data[i][$scope.type+'_sincronizable']=true;}
                    if ($scope.tabla.data[i][$scope.type+'_sincronizable']==0){$scope.tabla.data[i][$scope.type+'_sincronizable']=false;}
                    if ($scope.tabla.data[i][$scope.type+'_activa']==1){$scope.tabla.data[i][$scope.type+'_activa']=true;}
                    if ($scope.tabla.data[i][$scope.type+'_activa']==0){$scope.tabla.data[i][$scope.type+'_activa']=false;}
                    $scope.model[key]={sincronizable:$scope.tabla.data[i][$scope.type+'_sincronizable'],activa:$scope.tabla.data[i][$scope.type+'_activa'],key:''};
                }
            }
            else{
                for (var i in $scope.tabla.data){
                    //console.log($scope.tabla.data[i]);
                    var key=$scope.tabla.data[i]['cod_integracion_'+$scope.type];
                    if ($scope.tabla.data[i][$scope.type+'_sincronizable']==1){$scope.tabla.data[i][$scope.type+'_sincronizable']="Sincronizable";}
                    if ($scope.tabla.data[i][$scope.type+'_sincronizable']==0){$scope.tabla.data[i][$scope.type+'_sincronizable']="No Sincronizable";}
                    if ($scope.tabla.data[i][$scope.type+'_activa']==1){$scope.tabla.data[i][$scope.type+'_activa']="Activo";}
                    if ($scope.tabla.data[i][$scope.type+'_activa']==0){$scope.tabla.data[i][$scope.type+'_activa']="Inactivo";}
                    
                }
            }

		}
		vm.desBooleanizar=function(){
			
			for (var i in $scope.modelSave){
				if ($scope.modelSave[i].sincronizable==true){$scope.modelSave[i].sincronizable=1;}
				if ($scope.modelSave[i].sincronizable==false){$scope.modelSave[i].sincronizable=0;}
				if ($scope.modelSave[i].activa==true){$scope.modelSave[i].activa=1;}
				if ($scope.modelSave[i].activa==false){$scope.modelSave[i].activa=0;}
			}

		}
		vm.filter=function(){
			switch ($scope.type){
				case "docente":
					tablesServices.services.getDocente({newPage:1, pageSize:10,campus:$scope.myModel.selectedCampus}).$promise
					.then(function(data){
						$scope.tabla.data = data.data;
                        $scope.tabla.totalItems = data.size;
						$scope.booleanizar();
						console.log($scope.tabla.data);
					});
					break;
				case "periodo":
					tablesServices.services.getPeriod({newPage:1, pageSize:10,campus:$scope.myModel.selectedCampus}).$promise
					.then(function(data){
						$scope.tabla.data = data.data;
                        $scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
				case "cpjc":
					tablesServices.services.getCPJCarrera({newPage:1, pageSize:10,campus:$scope.myModel.selectedCampus}).$promise
					.then(function(data){
						$scope.tabla.data = data.data;
                        $scope.tabla.totalItems = data.size;
						$scope.booleanizar();
					});
					break;
			}
	       
		}
		vm.filterUnit=function(){
            $scope.modelSave={};
            $scope.model={};
            delete($scope.tabla.data);
			switch ($scope.type){
				case "aa":
					tablesServices.services.getMateriaActivity({newPage:1, pageSize:10,unidad:$scope.myModel.selectedUnidad}).$promise
						.then(function(data){
							$scope.tabla.data = data.data;
                            $scope.tabla.totalItems = data.size;
							$scope.booleanizar(); 
						});
					break;
				case "aau":
					tablesServices.services.getMateriaActivityUse({newPage:1, pageSize:10,unidad:$scope.myModel.selectedUnidad}).$promise
						.then(function(data){
							$scope.tabla.data = data.data;
                            $scope.tabla.totalItems = data.size;
							$scope.booleanizar(); 
						});
					break;
				case "uam":
					tablesServices.services.getUnidadAcademicaMateria({newPage:1, pageSize:10,unidad:$scope.myModel.selectedUnidad}).$promise
						.then(function(data){
							$scope.tabla.data = data.data;
                            $scope.tabla.totalItems = data.size;
							$scope.booleanizar(); 
						});
					break;
			}
	       
		}
		vm.filterCJ=function(){
					tablesServices.services.getModulo({newPage:1, pageSize:10,campus:$scope.myModel.selectedCampus,jornada:$scope.myModel.selectedJornada}).$promise
						.then(function(data){
							$scope.tabla.data = data.data;
                            $scope.tabla.totalItems = data.size;
							$scope.booleanizar(); 
						});
			
		}
		vm.filterC=function(){
					tablesServices.services.getPlanMateria({newPage:1, pageSize:10,carrera:$scope.myModel.selectedCarrera}).$promise
						.then(function(data){
							$scope.tabla.data = data.data;
                            $scope.tabla.totalItems = data.size;
							$scope.booleanizar(); 
						});
			
		}
		vm.filterD=function(){
					tablesServices.services.getAsignacionDocente({newPage:1, pageSize:10,apellido:$scope.myModel.filter}).$promise
						.then(function(data){
							$scope.tabla.data = data.data;
                            $scope.tabla.totalItems = data.size;
							$scope.booleanizar(); 
						});
			
		}
		vm.filterN=function(){
					tablesServices.services.getNotaClase({newPage:1, pageSize:10,id:$scope.myModel.selectedCampus}).$promise
						.then(function(data){
							$scope.tabla.data = data.data;
                            $scope.tabla.totalItems = data.size;
							$scope.booleanizar(); 
						});
					
		}
		vm.callFilter=function(){
			$scope.cataloguesCarreras=[];
			tablesServices.catalogues.getCatalogueCarreras({i:$scope.myModel.filter}).$promise
					.then(function(data){
						$scope.cataloguesCarreras = data;
						$scope.myModel.selectedCarrera=$scope.cataloguesCarreras.data[0].id_carrera;
						//vm.filterC();
					});
			
		}
		vm.saveChanges=function(){
			vm.desBooleanizar();
			tablesServices.updates.save({data:$scope.modelSave,type:$scope.type}).$promise
				.then(function(data){
					console.log(data);
					if(data.status == 0){
						ngNotify.set('Se han guardado los cambios de manera correcta.','success');
	            	}else{
	            		ngNotify.set('El servicio no responde.','error');
			        	
	            	}

			});
		}
        vm.getData=function(){
            var ex=[];
			for (var i in $scope.tabla.data){
                var ob={};
                for (var j in $scope.tabla.data[i]){if((j==$scope.type+'_sincronizable')||(j==$scope.type+'_activa')){
                        if ($scope.tabla.data[i][j]==true){ob[j]=1;}
                        if ($scope.tabla.data[i][j]==false){ob[j]=0;}
                    }else{
                        ob[j]=$scope.tabla.data[i][j];}
                }
                ex.push(ob);
            }
            return ex;	       
		}
		
		vm.ping = (currentStatus, url, filename, tipo) => {
			let params = {
				ID_EXECUTION: currentStatus.executionId, 
			}
			tablesServices.services.etlPing(params).$promise.then((response) => {
				if (!response.status) {
					let msn = response.messageError || vm.$translate('MSJ_ERROR')
					ngNotify.set(msn, 'warn')
				} else {
					this.executionStatus = response
					if (this.executionStatus.statusId == 1 || this.executionStatus.statusId == 2) {
						vm.$timeout(() => {
							this.ping(currentStatus, url, filename, tipo)
						}, 2000)
					} else if (this.executionStatus.statusId == 3 || this.executionStatus.statusId == 5) {
						vm.disableCSV=false
						ngNotify.set(this.executionStatus.statusExec, 'error')
					} else if (this.executionStatus.statusId == 4) {
						//LLAMADA A DESCARGAR EL ARCHIVO GENERADO
						uFunctions.download(url+'?tipo='+ tipo +'&id_user='+1+'&executionId='+currentStatus.executionId+'&filename='+currentStatus.filename, currentStatus.filename+'.'+tipo)
						vm.disableCSV=false
					}
				}
			}, (err) => {
				ngNotify.set('ejecución etlPing', 'error')
			})
		}

		vm.donwload = (url, tipo) => {
			let filename=$scope.type
			let params = {
				id_user : 1,
				tipo    : tipo,
				filename: filename 
			}
			vm.disableCSV=true
			let serviceGenerate
			switch ($scope.type){
	            case "nota"     : serviceGenerate  = tablesServices.services.getExportNota(params);break;
	            case "periodo"  : serviceGenerate  = tablesServices.services.getExportPeriodo(params);break;
	            case "pm"       : serviceGenerate  = tablesServices.services.getExportPlanmateria(params);break;
	            case "uam"      : serviceGenerate  = tablesServices.services.getExportUam(params);break;
	            case "cpjc"     : serviceGenerate  = tablesServices.services.getExportCPJCarrera(params);break;
	            case "dm"       : serviceGenerate  = tablesServices.services.getExportModulosporjornada(params);break;
	            case "institucion": serviceGenerate= tablesServices.services.getInstitutionsExport(params);break;
	            case "campus"   : serviceGenerate  = tablesServices.services.getCampusesExport(params);break;
	            case "jornada"  : serviceGenerate  = tablesServices.services.getShiftsExport(params);break;
	            case "carrera"  : serviceGenerate  = tablesServices.services.getExportCarrera(params);break;
	            case "plan"     : serviceGenerate  = tablesServices.services.getCareerspensumsExport(params);break;
	            case "unidad_academica":serviceGenerate=tablesServices.services.getAcademicunitExport(params);break;
	            case "actividad": serviceGenerate  = tablesServices.services.getActivitiesExport(params);break;
	            default: $scope.exporter=false;            
	        }
			serviceGenerate.$promise.then((response) => {
				if (!response.status) {
					let msn = response.messageError || vm.$translate('MSJ_ERROR')
					ngNotify.set(msn, 'warn')
				} else { 
					this.ping(response, url, filename, tipo)
				}
			}, (err) => {
				vm.disableCSV=false
				ngNotify.set(' Exports', 'error')
			})
		}

        vm.url=SERVICE_URL_CONSTANT.tablesFiltering;
        $scope.exporter=true;
        switch ($scope.type){
            case "nota":vm.url+="/exportNota";break;
            case "periodo":vm.url+="/exportPeriodo";break;
            case "pm":vm.url+="/exportPlanmateria";break;
            case "uam":vm.url+="/exportUam";break;
            case "cpjc":vm.url+="/exportCpjcp";break;
            case "dm":vm.url+="/exportModulosporjornada";break;
            case "institucion":vm.url+="/institutionsExport";break;
            case "campus":vm.url+="/campusesExport";break;
            case "jornada":vm.url+="/shiftsExport";break;
            case "carrera":vm.url+="/exportCarrera";break;
            case "plan":vm.url+="/careerspensumsExport";break;
            case "unidad_academica":vm.url+="/academicunitExport";break;
            case "actividad":vm.url+="/activitiesExport";break;
            default: $scope.exporter=false;            
        }
        vm.urlxls=vm.url+"?tipo=xls"; 
        console.log('vm.url...',vm.url)
        vm.exportAllpdf=function(){
            $window.open(url+"?tipo=pdf");
            
        }
        
        var selectService=function(newPage,pageSize,grid){
              var filters={}
              for(let i in grid.columns){
                  if ((grid.columns[i].filters[0].term!='')&&(grid.columns[i].filters[0].term!=undefined)){
                      filters[grid.columns[i].field]=grid.columns[i].filters[0].term;
                  }
              }
              switch($scope.type){
                            case 'campus':
                                tablesServices.services.getCampus({newPage:newPage, pageSize:pageSize,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar();
                                    });
                                break;
                            case 'jornada':
                                tablesServices.services.getJornada({newPage:newPage, pageSize:pageSize,filters:filters, campus: $scope.myModel.selectedCampus}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar();
                                    });
                                    
                                break;
                            case 'actividad':
                                tablesServices.services.getActivity({newPage:newPage, pageSize:pageSize,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar();
                                    });
                                break;
                            case 'institucion':
                                tablesServices.services.getInstitution({newPage:newPage, pageSize:pageSize,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar();
                                    });
                                break;
                            case 'unidad_academica':
                                tablesServices.services.getUnidadAcademica({newPage:newPage, pageSize:pageSize,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar();
                                    });

                                break;
                            case "tipo_uso":
                                tablesServices.services.getTipoUso({newPage:newPage, pageSize:pageSize,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.totalItems = data.size;
                                        $scope.tabla.data = data.data;
                                        $scope.booleanizar();
                                    });

                                    break;
                            case "carrera":
                                tablesServices.services.getCarrera({newPage:newPage, pageSize:pageSize,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar();
                                    });

                                    break;
                            case "ccepr":
                                tablesServices.services.getRecurso({newPage:newPage, pageSize:pageSize,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar();
                                    });

                                    break;
                            case "cceprt":
                                tablesServices.services.getRecursoTipoUso({newPage:newPage, pageSize:pageSize,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar();
                                    });

                                    break;
                            case 'docente':
                                tablesServices.services.getDocente({newPage:newPage, pageSize:pageSize,filters:filters}).$promise
                                .then(function(data){
                                    $scope.tabla.data = data.data;
                                    $scope.tabla.totalItems = data.size;
                                    $scope.booleanizar();
                                });
                                

                                break;
                            case 'periodo':
                                tablesServices.services.getPeriod({newPage:newPage, pageSize:pageSize,campus:$scope.myModel.selectedCampus,filters:filters}).$promise
                                    .then(function(data){
                                    $scope.tabla.data = data.data;
                                    $scope.tabla.totalItems = data.size;
                                    $scope.booleanizar();
                                    });

                                break;
                            case 'pm':
                                tablesServices.services.getPlanMateria({newPage:newPage, pageSize:pageSize,carrera:$scope.myModel.selectedCarrera,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar(); 
                                    });
                                break;
                            case 'ad':
                                tablesServices.services.getAsignacionDocente({newPage:newPage, pageSize:pageSize,apellido:$scope.myModel.filter,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar(); 
                                    });
                                
                                break;
                            case 'nota':
                                tablesServices.services.getNotaClase({newPage:newPage, pageSize:pageSize,id:$scope.myModel.selectedCampus,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar(); 
                                    });
                                break;
                            case 'cpjc':
                            	tablesServices.services.getCPJCarrera({newPage:newPage, pageSize:pageSize,campus:$scope.myModel.selectedCampus,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar();
                                    });
                                break;
                            case 'dm':
                                tablesServices.services.getModulo({newPage:newPage, pageSize:pageSize,campus:$scope.myModel.selectedCampus,jornada:$scope.myModel.selectedJornada,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar(); 
                                    });
                                break;
                            case 'plan':
                                tablesServices.services.getTable({newPage:newPage, pageSize:pageSize,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar();
                                    });

                                    break;
                            case "aa":
                                tablesServices.services.getMateriaActivity({newPage:newPage, pageSize:pageSize,unidad:$scope.myModel.selectedUnidad,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar(); 
                                    });
                                break;
                            case "aau":
                                tablesServices.services.getMateriaActivityUse({newPage:newPage, pageSize:pageSize,unidad:$scope.myModel.selectedUnidad,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar(); 
                                    });
                                break;
                            case "uam":
                                tablesServices.services.getUnidadAcademicaMateria({newPage:newPage, pageSize:pageSize,unidad:$scope.myModel.selectedUnidad,filters:filters}).$promise
                                    .then(function(data){
                                        $scope.tabla.data = data.data;
                                        $scope.tabla.totalItems = data.size;
                                        $scope.booleanizar(); 
                                    });
                                break;
                        
                        }
            
        }
		
	}
}

tableCtrl.$inject = ['$rootScope', '$scope', '$http' , '$filter','tablesServices','$stateParams','ngNotify','SERVICE_URL_CONSTANT','$window','permissions','permissionList', 'uFunctions', '$timeout'];





// WEBPACK FOOTER //
// ./src/app/integration-front/tables/tableCtrl.js